import { Julia } from './Julia';

new Julia();



// WEBPACK FOOTER //
// ../node_modules/tslint-loader??ref--0!./julia/ts/App.ts